import { loadYoutubeApi } from '../../js/helper';

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $contentVideos = $context.querySelectorAll('[data-contentvideo="root"]');
        const $howToVideos = $context.querySelectorAll('[data-howtovideos="root"]');
        const $mediaSlider = $context.querySelectorAll('[data-mediaslider-video="root"]');

        const removeRestriction = (media) => {
            if (media) {
                const $placeholder = media.querySelector('.media__restriction');

                if ($placeholder) {
                    $placeholder.remove();
                }
            }
        };

        const showRestriction = (media) => {
            if (media) {
                const $placeholder = media.querySelector('.media__restriction');

                if ($placeholder) {
                    $placeholder.classList.add('is--shown');
                }
            }
        };

        if ($contentVideos.length > 0 || $howToVideos.length > 0 || $mediaSlider.length > 0) {
            const waitForConsent = setInterval(() => {
                if (typeof CookieConsent !== 'undefined') {
                    clearInterval(waitForConsent);
                    if (CookieConsent.consent.marketing === true) { // eslint-disable-line
                        loadYoutubeApi();

                        window.onYouTubeIframeAPIReady = () => {
                            if ($contentVideos.length > 0) {
                                import('../../modules/content-video/content-video').then(({ ContentVideo }) => {
                                    $contentVideos.forEach((media, i) => {
                                        const contentVideoAPI = new ContentVideo($contentVideos[i]);
                                        $contentVideos[i].API = contentVideoAPI;
                                        removeRestriction(media);
                                    });
                                });
                            }

                            if ($howToVideos.length > 0) {
                                import('../../modules/how-to-videos/how-to-videos').then(({ HowToVideos }) => {
                                    $howToVideos.forEach((media, i) => {
                                        const howToVideosAPI = new HowToVideos($howToVideos[i], {
                                            loader: window.OPTIONS.loader,
                                            resizeHandler: window.resizeHandler
                                        });
                                        howToVideosAPI.API = howToVideosAPI;
                                        removeRestriction(media);
                                    });
                                });
                            }

                            if ($mediaSlider.length > 0) {
                                import('../../modules/media-slider/media-slider').then(({ MediaSlider }) => {
                                    $mediaSlider.forEach((media, i) => {
                                        const mediaSlider = new MediaSlider($mediaSlider[i]);
                                        mediaSlider.initialize();
                                        removeRestriction(media);
                                    });
                                });
                            }
                        };
                    } else {
                        if ($contentVideos.length > 0) {
                            $contentVideos.forEach((media) => {
                                showRestriction(media);
                            });
                        }

                        if ($howToVideos.length > 0) {
                            $howToVideos.forEach((media) => {
                                showRestriction(media);
                            });
                        }

                        if ($mediaSlider.length > 0) {
                            $mediaSlider.forEach((media) => {
                                showRestriction(media);
                            });
                        }
                    }
                } else {
                    console.log('waiting for CookieContent');
                }
            }, 300);
        }
    }
});
